import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, {
	resetRouter
} from '@/router'

const state = {
	token: getToken(),
	name: '',
	avatar: '',
	introduction: '',
	roles: [],
	userType: '', // 0 是主账号，1是子账户
	roleCode: '',
	lable:'',
	franchiseeNo:'',
	erpCusNo:'',
	franchiseeName:'',
	storeNo:'',
	storeName:'',
	parentUserId:'',
	userId:'',
	refDisNo:'', //折扣编码
	brandIds:'',
	roleGroupCode:'',
	keyValues:[],//充值白名单
	code:'',//有会员卡
	storeStatus:'',//店铺状态
	franchiseeStatus:'', //加盟商状态
	userInfo: {}
}

const mutations = {
	SET_KEYVALUES: (state, keyValues) => {
		state.keyValues = keyValues
	},
	SET_STORESTATUS: (state, storeStatus) => {
		state.storeStatus = storeStatus
	},
	SET_FRANCHISEESTATUS: (state, franchiseeStatus) => {
		state.franchiseeStatus = franchiseeStatus
	},
	SET_ROLEGROUPCODE: (state, roleGroupCode) => {
		state.roleGroupCode = roleGroupCode
	},
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_FRANCHISEENAME: (state, franchiseeName) => {
		state.franchiseeName = franchiseeName
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_BRANDIDS: (state, brandIds) => {
		state.brandIds = brandIds
	},
	SET_USERID: (state, userId) => {
		state.userId = userId
	},
	SET_PARENTUSERID: (state, parentUserId) => {
		state.parentUserId = parentUserId
	},
	SET_FRANCHISEENO: (state, franchiseeNo) => {
		state.franchiseeNo = franchiseeNo
	},
	SET_ERPCUSNO: (state, erpCusNo) => {
		state.erpCusNo = erpCusNo
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_USERTYPE: (state, userType) => {
		state.userType = userType
	},
	SET_ROLECODE: (state, roleCode) => {
		state.roleCode = roleCode
	},
	SET_LABLE: (state, lable) => {
		state.lable = lable
	},
	SET_STORENAME: (state, storeName) => {
		state.storeName = storeName
	},
	SET_STORENO: (state, storeNo) => {
		state.storeNo = storeNo
	},
	SET_REFDISNO: (state, refDisNo) => {
		state.refDisNo = refDisNo
	},
	SET_CODE: (state , code) =>{
		state.code = code
	},
	SET_USERINFO: (state, data) => {
		state.userInfo = data
	}
}

const actions = {
	// user login
	login({
		commit
	}, userInfo) {
		const {
			mobile,
			password,
			type,
			code
		} = userInfo
		return new Promise((resolve, reject) => {

			login({
				mobile: mobile.trim(),
				password: password,
				type:type,
				code:code,
				loginChannel:'m'//pc前端登录
			}).then(response => {
				const {
					data
				} = response
				commit('SET_TOKEN', data.token)
				commit('SET_KEYVALUES', data.keyValues)
				setToken(data.token)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// get user info
	getInfo({
		commit,
		state,
		dispatch
	}) {

		return new Promise((resolve, reject) => {
			getInfo(state.token).then(response => {

				const {
					data
				} = response
				if(!data) {
					reject('请重新登录！')
				}
				const {
					roles,
					userName,
					photo,
					introduction,
					type,
					roleCode,
					lable,
					franchiseeNo,
					erpCusNo,
					franchiseeName,
					storeNo,
					storeName,
					parentUserId,
					userId,
					refDisNo,
					brandIds,
					roleGroupCode,
					keyValues,
					code,
					storeStatus,
					franchiseeStatus
				} = data

				// roles must be a non-empty array
				if(!roles || roles.length <= 0) {
					reject('账号权限异常!')
				}

				commit('SET_ROLES', roles)
				commit('SET_STORESTATUS', storeStatus)
				commit('SET_FRANCHISEESTATUS', franchiseeStatus)
				commit('SET_KEYVALUES', keyValues)
				commit('SET_USERTYPE', type)
				commit('SET_NAME', userName)
				commit('SET_AVATAR', photo)
				commit('SET_INTRODUCTION', introduction)
				commit('SET_ROLECODE', roleCode)
				commit('SET_LABLE', lable)
				commit('SET_FRANCHISEENO', franchiseeNo)
				commit('SET_ERPCUSNO', erpCusNo)
				commit('SET_FRANCHISEENAME', franchiseeName)
				commit('SET_STORENAME', storeName)
				commit('SET_STORENO', storeNo)
				commit('SET_PARENTUSERID', parentUserId)
				commit('SET_USERID', userId)
				commit('SET_REFDISNO', refDisNo)
				commit('SET_BRANDIDS', brandIds)
				commit('SET_ROLEGROUPCODE', roleGroupCode)
				commit('SET_CODE',code)
				commit('SET_USERINFO', data)
				dispatch('cart/getCarts', {}, { root: true })
				resolve(data)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// user logout
	logout({
		commit,
		state,
		dispatch
	}) {
		return new Promise((resolve, reject) => {
			logout(state.token).then(() => {
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				commit('SET_USERTYPE', '')
				commit('SET_NAME', '')
				commit('SET_AVATAR', '')
				commit('SET_INTRODUCTION', '')
				commit('SET_ROLECODE', '')
				commit('SET_LABLE', '')
				commit('SET_FRANCHISEENO', '')
				commit('SET_ERPCUSNO', '')
				commit('SET_FRANCHISEENAME', '')
				commit('SET_STORENAME', '')
				commit('SET_STORENO', '')
				commit('SET_PARENTUSERID', '')
				commit('SET_USERID', '')
				commit('SET_REFDISNO', '')
				commit('SET_BRANDIDS', '')
				commit('SET_ROLEGROUPCODE', '')
				commit('SET_KEYVALUES', [])
				commit('SET_CODE', '')
				commit('SET_STORESTATUS', '')
				commit('SET_FRANCHISEESTATUS', '')
				commit('SET_USERINFO', {})
				removeToken()
				resetRouter()
				dispatch('tagsView/delAllViews','/', {
					root: true
				})

				// reset visited views and cached views
				// to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// remove token
	resetToken({
		commit
	}) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			removeToken()
			resolve()
		})
	},

	// dynamically modify permissions
	changeRoles({
		commit,
		dispatch
	}, role) {
		return new Promise(async resolve => {
			const token = role + '-token'

			commit('SET_TOKEN', token)
			setToken(token)

			const {
				roles
			} = await dispatch('getInfo')

			resetRouter()

			// generate accessible routes map based on roles
			const accessRoutes = await dispatch('permission/generateRoutes', roles, {
				root: true
			})

			// dynamically add accessible routes
			router.addRoutes(accessRoutes)

			// reset visited views and cached views
			dispatch('tagsView/delAllViews', null, {
				root: true
			})

			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
